import * as yup from 'yup';

// Single reusable UK postcode validation function
export const createUKPostcodeValidation = (fieldName = 'Postcode') =>
  yup
    .string()
    .test(
      'postcode-format',
      `${fieldName} must be a valid UK postcode (e.g., SW1A 1AA, M1 1AA, B33 8TH)`,
      (value) => {
        if (fieldName === 'Business Postcode') {
          return true;
        }

        return /^[a-z]{1,2}\d[a-z\d]?\s*\d[a-z]{2}$/i.test(value);
      }
    )
    .transform((value) => value?.trim().replace(/\s+/g, ' ').toUpperCase());
